import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RejectionData } from '../../aftale/models';

@Component({
    selector: 'app-reject-posteringer-dialog',
    templateUrl: './reject-posteringer-dialog.component.html',
    styleUrls: ['./reject-posteringer-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RejectPosteringerDialogComponent implements OnInit {
  form: UntypedFormGroup;

  get note() {
    return this.form.get('note');
  }

  constructor(private fb: UntypedFormBuilder, private dialog: MatDialogRef<RejectPosteringerDialogComponent>) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      note: [null, [Validators.required]],
    });
  }

  save() {
    let data: RejectionData = {
      confirm: true,
      rejectionRemark: this.note.value,
    };
    this.dialog.close(data);
  }
}
